import cloneDeep from "lodash-es/cloneDeep"

import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import { generateUUID } from "shared/lib/generateUUID"
import { sortByPosition } from "shared/lib/sorting/sortByPosition"
import { ProductPosition } from "shared/types/ProductPosition"
import { ProductPositionsAPIType } from "shared/types/Project"

import { getProductType } from "entities/products/lib/getProductType"

export function transformProductPosition(
  productPosition: ProductPosition
): ProductPosition {
  return {
    ...productPosition,
    references: productPosition?.references
      ? sortByPosition(cloneDeep(productPosition.references))
      : null,
    addons: productPosition?.addons?.map(addon => ({
      ...addon,
      parentProductType: getProductType(productPosition.variantKey),
      id: generateUUID()
    }))
  }
}

export const productPositionResponseTransformer = createResponseTransformer(
  json => {
    // json-api-serializer declares `deserialize` as `any`; the product position
    // shape is asserted once here so nothing downstream has to.
    const deserialized = cloneDeep(
      serializer.deserialize(
        ProductPositionsAPIType,
        transformJsonApiResponse(json)
      )
    ) as ProductPosition | ProductPosition[]

    if (Array.isArray(deserialized)) {
      return deserialized.map(transformProductPosition)
    }

    return transformProductPosition(deserialized)
  }
)
